
export const createRectangularWindow = (fftSize) => {
    return new Float32Array(fftSize).fill(1);
};

export const createHannWindow = (fftSize) => {
    const window = new Float32Array(fftSize);
    for (let n = 0; n < fftSize; n++) {
        window[n] = 0.5 * (1 - Math.cos((2 * Math.PI * n) / (fftSize - 1)));
    }
    return window;
};

export const createHammingWindow = (fftSize) => {
    const window = new Float32Array(fftSize);
    for (let n = 0; n < fftSize; n++) {
        window[n] = 0.54 - 0.46 * Math.cos((2 * Math.PI * n) / (fftSize - 1));
    }
    return window;
};

export const createBlackmanWindow = (fftSize) => {
    const window = new Float32Array(fftSize);

    const alpha = 0.16;
    const a0 = 0.5 * (1 - alpha);
    const a1 = 0.5;
    const a2 = 0.5 * alpha;

    for (let i = 0; i < fftSize; i++) {
        const x = i / fftSize;
        window[i] = a0 - a1 * Math.cos(2 * Math.PI * x) + a2 * Math.cos(4 * Math.PI * x);
    }

    return window;
};

export const createFlatTopWindow = (fftSize) => {
    const a0 = 1.0, a1 = 1.93, a2 = 1.29, a3 = 0.388, a4 = 0.028;
    const window = new Float32Array(fftSize);
    for (let n = 0; n < fftSize; n++) {
        window[n] = a0 - a1 * Math.cos((2 * Math.PI * n) / (fftSize - 1)) + a2 * Math.cos((4 * Math.PI * n) / (fftSize - 1)) - a3 * Math.cos((6 * Math.PI * n) / (fftSize - 1)) + a4 * Math.cos((8 * Math.PI * n) / (fftSize - 1));
    }
    return window;
};